<template>
  <div class="app-dl">
    <div class="app-dl-card">
      <img class="logo" src="/brand-logo.png" alt="华锐智造云" />
      <h1>华锐智造云 App</h1>
      <p class="sub">项目现场作业 · 随时随地协同</p>

      <template v-if="inWeChat">
        <div class="wx-tip">
          <p class="wx-title">请在浏览器中打开</p>
          <p class="wx-desc">点击右上角 <b>···</b>，选择「在浏览器中打开」后即可下载</p>
          <div class="wx-guide" aria-hidden="true">
            <span class="arrow">↗</span>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="btns">
          <a
            class="btn android"
            :class="{ disabled: !androidUrl }"
            :href="androidUrl || 'javascript:;'"
            :target="androidUrl ? '_blank' : undefined"
            rel="noopener"
            @click="onDownload('android', $event)"
          >
            <span class="btn-label">安卓版下载</span>
            <span class="btn-hint">{{ androidUrl ? 'Android APK' : '下载地址即将开放' }}</span>
          </a>
          <a
            class="btn ios"
            :class="{ disabled: !iosUrl }"
            :href="iosUrl || 'javascript:;'"
            :target="iosUrl ? '_blank' : undefined"
            rel="noopener"
            @click="onDownload('ios', $event)"
          >
            <span class="btn-label">iOS 版下载</span>
            <span class="btn-hint">{{ iosUrl ? 'App Store' : '暂不开放' }}</span>
          </a>
        </div>
        <p class="foot">如无法下载，请复制链接到系统浏览器打开</p>
      </template>
    </div>
  </div>
</template>

<script>
import { APP_DOWNLOAD } from '../config/appDownload'

export default {
  name: 'AppDownload',
  data() {
    return {
      inWeChat: false,
      androidUrl: APP_DOWNLOAD.androidUrl || '',
      iosUrl: APP_DOWNLOAD.iosUrl || ''
    }
  },
  created() {
    const ua = (navigator.userAgent || '')
    this.inWeChat = /MicroMessenger/i.test(ua)
  },
  methods: {
    onDownload(platform, e) {
      const url = platform === 'ios' ? this.iosUrl : this.androidUrl
      if (!url) {
        e.preventDefault()
        this.$message && this.$message.warning(
          platform === 'ios' ? 'iOS 版暂不开放' : '下载地址即将开放，请稍后再试'
        )
      }
    }
  }
}
</script>

<style scoped>
.app-dl {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background: linear-gradient(160deg, #eff6ff 0%, #f8fafc 50%, #e0f2fe 100%);
  box-sizing: border-box;
}
.app-dl-card {
  width: 100%;
  max-width: 380px;
  text-align: center;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 36px 24px 28px;
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.06);
}
.logo {
  width: 64px;
  height: 64px;
  border-radius: 14px;
  object-fit: contain;
  background: #fff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
}
h1 {
  margin: 14px 0 6px;
  font-size: 22px;
  color: #0f172a;
  font-weight: 800;
}
.sub {
  margin: 0 0 28px;
  color: #64748b;
  font-size: 13px;
}
.wx-tip {
  position: relative;
  padding: 20px 16px;
  border-radius: 12px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  text-align: left;
}
.wx-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 700;
  color: #92400e;
}
.wx-desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.7;
  color: #78350f;
}
.wx-guide {
  position: absolute;
  top: -8px;
  right: 8px;
  font-size: 28px;
  color: #f59e0b;
  line-height: 1;
  animation: bounce 1.2s ease-in-out infinite;
}
@keyframes bounce {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(4px, -6px); }
}
.btns {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.btn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 16px 18px;
  border-radius: 12px;
  text-decoration: none;
  color: #fff;
  transition: opacity 0.15s, transform 0.15s;
}
.btn:active { transform: scale(0.98); }
.btn.android { background: linear-gradient(135deg, #16a34a, #15803d); }
.btn.ios { background: linear-gradient(135deg, #0f172a, #334155); }
.btn.disabled {
  background: #e2e8f0;
  color: #64748b;
  pointer-events: auto;
  cursor: not-allowed;
}
.btn-label { font-size: 16px; font-weight: 700; }
.btn-hint { font-size: 12px; opacity: 0.85; }
.foot {
  margin: 18px 0 0;
  font-size: 12px;
  color: #94a3b8;
}
</style>
